/**
 * 系统管理 提现发放
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>提现发放</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-select size="small" v-model="formInline.payStatus" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="待审核" value="0"></el-option>
          <el-option label="审核通过" value="1"></el-option>
          <el-option label="已发放" value="2"></el-option>
          <el-option label="审核不通过" value="3"></el-option>
          <el-option label="发放失败" value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="primary" @click="handleunit()">部门设置</el-button> -->
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="id" label="ID">
      </el-table-column>
      <el-table-column align="center" prop="phone" label="手机号" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="createTime" label="提现时间" min-width="140">
      </el-table-column>
      <el-table-column align="center" prop="money" label="提现金额" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="type" label="类型" min-width="120">
        <template slot-scope="scope">
          <div>{{scope.row.type=='alipay'? '支付宝': '微信'}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="account" label="账号" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="name" label="姓名" min-width="120">
      </el-table-column>
      <el-table-column align="center" prop="status" label="状态" min-width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">待审核</div>
          <div v-else-if="scope.row.status == 1">审核通过</div>
          <div v-else-if="scope.row.status == 2">已发放</div>
          <div v-else-if="scope.row.status == 3">审核不通过</div>
          <div v-else-if="scope.row.status == 4">发放失败</div>
          <div v-else></div>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center"  prop="isLock" label="状态" min-width="50">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isLock=='N'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" fixed="right"  align="center">
        <template slot-scope="scope">
          <el-button size="mini" :disabled="scope.row.status != 1" @click="deleteUser(scope.$index, scope.row)">发放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {
  userCrashPay, userCrashPage
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      editForm: {
        userId: '',
        userName: '',
        userRealName: '',
        roleId: '',
        userMobile: '',
        userEmail: '',
        userSex: '',
        token: localStorage.getItem('logintoken')
      },
      // 部门参数
      unitparm: {
        userIds: '',
        deptId: '',
        deptName: ''
      },
      // 选择数据
      selectdata: [],
      // 删除用户
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      // 重置密码
      resetpsd: {
        userId: '',
        token: localStorage.getItem('logintoken')
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        pageNo: 0,
        pageSize: 10,
        payStatus: "",
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      userCrashPage(parameter).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.data.dataList
          // 分页赋值
          // this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.pageSize
          this.pageparm.total = res.data.totalCount
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.formInline.pageNo = 0
      this.getdata(this.formInline)
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 发放
    deleteUser(index, row) {
      if(row.status != 1){
        this.$message({
          type: 'error',
          message: '需审核成功再提现!'
        })
        return
      }
      this.$confirm('确定要发放吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          userCrashPay({id: row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '提现已发放!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.data
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('提现失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/user.vue